// extracted by mini-css-extract-plugin
export default {"filterTag":"FilterTag_filterTag__+6Vgi","removeFilter":"FilterTag_removeFilter__rvuBF","imageTag":"FilterTag_imageTag__kVXz7","disabled":"FilterTag_disabled__KN-Co"};